<template lang="pug">
  v-card
    v-card-title
      h2.modal-title {{ 'auth.change_password' | translate }}
    v-card-content
      v-input-r(
        :label="'auth.new_password' | translate"
        v-model="form.password")
      v-input-r(
        :label="'auth.repite_password' | translate"
        v-model="form.password_repeat")
    v-card-actions
      v-btn(
        :disabled="!isPasswordValid"
        :loading="loading"
        @click="onUpdate") {{ 'base.save' | translate }}
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ChangePasswordClientModal',

  props: {
    id: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    form: {
      password: '',
      password_repeat: ''
    },
    loading: false
  }),

  computed: {
    isPasswordValid () {
      return this.form.password.length >= 8 &&
        this.form.password === this.form.password_repeat
    }
  },

  methods: {
    ...mapActions('dashboard', [
      'changeUserPassword'
    ]),

    async onUpdate () {
      this.loading = true
      const payload = {
        password: this.form.password
      }
      const error = await this.changeUserPassword(payload)
      this.loading = false
      if (!error) {
        this.$emit('close')
      } else {
        this.$toasted.show('Пароль не повинен cкладатися лише з цифр')
      }
    }
  }
}
</script>
<style scoped>
.v-card__title {
  padding: 2rem 2.4rem 1.6rem;
}

.modal-title {
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
}

.v-card__content {
  border-top: .1rem solid #d7d7d7;
  padding-bottom: 1.5rem !important;
}

.v-card__actions {
  padding: 0 2.4rem 2.4rem;
}

.v-card__actions button {
  width: 100%;
}
</style>
